'use client';

import { SidebarMenuItem, SidebarMenuButton } from '@ui/components/ui/sidebar';
import { MessageSquareText } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { FeedbackDialog } from '@/components/feedback-dialog';

export default function NavFeedback() {
  const t = useTranslations('Navigation');
  const [open, setOpen] = useState(false);

  return (
    <>
      <SidebarMenuItem>
        <SidebarMenuButton tooltip={t('shareFeedback')} onClick={() => setOpen(true)}>
          <MessageSquareText />
          <span>{t('shareFeedback')}</span>
        </SidebarMenuButton>
      </SidebarMenuItem>
      <FeedbackDialog open={open} onOpenChange={setOpen} />
    </>
  );
}
